import React, { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, { PaginationProvider }  from "react-bootstrap-table2-paginator";
import * as actions from "../../../../../_redux/private-notices/PrivateNoticesAction";
import * as uiHelpers from "../SectionsUIHelpers";
import { 
  getHandlerTableChange,  
  NoRecordsFoundMessage, 
  PleaseWaitMessage, 
  sortCaret
} from "../../../../../../../../_metronic/_helpers";
import { Pagination } from "../../../../../../../../_metronic/_partials/controls";
import { useSectionsUIContext } from "../SectionsUIContext";

export function SectionsTable() {
  // Sections UI Context
  const sectionsUIContext = useSectionsUIContext();
  const sectionsUIProps = useMemo(() => {
    return {
      queryParams: sectionsUIContext.queryParams,
      setQueryParams: sectionsUIContext.setQueryParams
    };
  }, [sectionsUIContext]);

  // Getting curret state of Sections list from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.privateNotices }),
    shallowEqual
  );
  const { totalCount, entities, listLoading } = currentState;
  
  // Section Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.getReceipentSections(sectionsUIProps.queryParams));
    return () => dispatch(actions.cleanListState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionsUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "gradeLevelName",
      text: "Sınıf Düzeyi",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "grade",
      text: "Sınıf",
      sort: true,
      sortCaret: sortCaret,
    },    
    {
      dataField: "name",
      text: "Şube",
      sort: true,
      sortCaret: sortCaret,
    },
    {
      dataField: "courseName",
      text: "Ders",
      sort: true,
      sortCaret: sortCaret,
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: sectionsUIProps.queryParams.pageSize,
    page: sectionsUIProps.queryParams.pageNumber
  };
  
  return (
    <PaginationProvider pagination={paginationFactory(paginationOptions)}>
      {({ paginationProps, paginationTableProps }) => {
        return (
          <Pagination
            isLoading={listLoading}
            paginationProps={paginationProps}
          >
            <BootstrapTable
              wrapperClasses="table-responsive"
              classes="table table-head-custom table-vertical-center overflow-hidden"
              bootstrap4
              bordered={false}
              remote
              keyField="id"
              data={entities ? entities : [] }
              columns={columns}
              defaultSorted={uiHelpers.defaultSorted}
              onTableChange={getHandlerTableChange(
                sectionsUIProps.setQueryParams
              )}
              {...paginationTableProps}
            >
              <PleaseWaitMessage entities={entities} />
              <NoRecordsFoundMessage entities={entities} />
            </BootstrapTable>
          </Pagination>
        );    
      }}
    </PaginationProvider>  
  );
}